import React from 'react';
import { X, Sparkles } from 'lucide-react';

export const GuestForm = ({ 
  newGuest, 
  setNewGuest, 
  tagInput, 
  setTagInput, 
  isEditing, 
  onReset, 
  onSubmit,
  compact = false,
}) => {


const handleTagKeyDown = (e) => {
  if ((e.key === 'Enter' || e.key === ',') && tagInput.trim() !== "") {
    e.preventDefault();
    const newTagName = tagInput.trim().replace(',', '');
    
    // Check if the tag already exists in the current list (compare against strings or .name)
    const isDuplicate = newGuest.group_tags.some(tag => {
      const existingName = typeof tag === 'string' ? tag : tag.name;
      return existingName.toLowerCase() === newTagName.toLowerCase();
    });

    if (!isDuplicate) {
      setNewGuest(prev => ({
        ...prev,
        // We add new tags as strings; the backend handles turning them into objects
        group_tags: [...prev.group_tags, newTagName]
      }));
    }
    setTagInput("");
  }
};

const removeTag = (indexToRemove) => {
  setNewGuest(prev => ({
    ...prev,
    group_tags: prev.group_tags.filter((_, index) => index !== indexToRemove)
  }));
};

  return (
    <section className={`${compact ? "bg-white p-0" : "bg-white p-8 rounded-[40px] shadow-2xl border border-white"} ${compact ? "space-y-3" : "space-y-4"}`}>
      {!compact && (
        <h3 className="text-xl font-black text-gray-800 ml-1">
          {isEditing ? "Edit Guest Details" : "Add New Guest"}
        </h3>
      )}
      <p className={`${compact ? "text-[11px] leading-4" : "text-xs leading-5"} ml-1 font-semibold text-gray-400`}>
        Name and email are enough to send a standard invite. Groups and messages are optional.
      </p>
      
      <div className={compact ? "space-y-3" : "space-y-4"}>
        <input 
          placeholder="Guest Name" 
          className={`${compact ? "p-3 text-sm" : "p-4"} w-full bg-gray-50 rounded-2xl outline-none`}
          value={newGuest.guest_name} 
          onChange={e => setNewGuest({...newGuest, guest_name: e.target.value})} 
        />
        <input 
          placeholder="Email" 
          className={`${compact ? "p-3 text-sm" : "p-4"} w-full bg-gray-50 rounded-2xl outline-none`}
          value={newGuest.email_id} 
          onChange={e => setNewGuest({...newGuest, email_id: e.target.value})} 
        />
        
        <div className="space-y-2">
          <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1">Groups</label>
          <div className={`${compact ? "min-h-[48px]" : "min-h-[56px]"} p-2 bg-gray-50 rounded-2xl flex flex-wrap gap-2 items-center border border-transparent focus-within:border-pink-200 transition-all`}>
            {newGuest.group_tags.map((tag, index) => (
              <span key={index} className="flex items-center gap-1 px-3 py-1 bg-[#ff0099] text-white text-xs font-bold rounded-full">
                {typeof tag === 'string' ? tag : tag.name}
                <button onClick={() => removeTag(index)}><X size={12} /></button>
              </span>
            ))}
            <input 
              className="flex-1 min-w-[80px] bg-transparent outline-none text-sm p-2"
              placeholder="e.g. Family"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyDown={handleTagKeyDown}
            />
          </div>
        </div>

        <div className="relative">
          <textarea 
          placeholder="Optional personal message" 
            className={`${compact ? "h-20 p-3 text-sm" : "h-24 p-4"} w-full bg-gray-50 rounded-2xl outline-none`}
            value={newGuest.personal_message} 
            onChange={e => setNewGuest({...newGuest, personal_message: e.target.value})} 
          />
          <Sparkles className="absolute bottom-4 right-4 text-[#ff0099]" size={18} />
        </div>

        <div className="flex gap-3">
          <button 
            onClick={onSubmit} 
            className={`flex-1 ${compact ? "py-3.5 text-sm" : "py-5 text-lg"} rounded-[25px] font-black transition-all ${isEditing ? 'bg-[#ff0099] text-white' : 'bg-gray-900 text-white'}`}
          >
            {isEditing ? "Update Guest" : "Add Guest"}
          </button>
          {isEditing && (
            <button onClick={onReset} className={`${compact ? "px-4 py-3.5 text-sm" : "px-6 py-5"} bg-gray-100 text-gray-500 rounded-[25px] font-bold`}>
              Cancel
            </button>
          )}
        </div>
      </div>
    </section>
  );
};
